import { MerchantNotificationsEventNamesType } from 'config/requests/merchants';
import {
  MerchantsShowNotificationsForm,
  MerchantsShowNotificationsFormValues,
} from 'pages/Merchants/MerchantsShow/MerchantsShowNotifications/components/MerchantsShowNotificationsForm/MerchantsShowNotificationsForm';
import { CreateStyled } from 'pages/Merchants/MerchantsShow/MerchantsShowNotifications/components/MerchantsShowNotificationsForm/MerchantsShowNotificationsForm.styled';
import { useCreateMerchantNotification } from 'pages/Merchants/MerchantsShow/MerchantsShowNotifications/hooks/useCreateMerchantNotification';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { queryClient } from 'providers/queryClient';
import { Form } from 'react-admin';
import { FieldValues } from 'react-hook-form';
import { Button } from 'shared/mui/Buttons';
import { CardActionsButtons } from 'shared/mui/Card';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { Dialog } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';

type Props = {
  open: boolean;
  onClose: VoidFunction;
  merchantId: string;
  eventNames?: MerchantNotificationsEventNamesType[];
};

export const MerchantsShowNotificationsCreateDialog: React.FC<Props> = ({
  eventNames,
  open,
  onClose,
  merchantId,
}) => {
  const translate = useTypedTranslate();

  const { createMerchantNotification, isLoading } = useCreateMerchantNotification(
    merchantId,
    () => {
      onClose();
      queryClient.invalidateQueries({ queryKey: ['merchant_notification_settings'] });
    },
  );

  return (
    <Dialog maxWidth="md" onClose={onClose} open={open}>
      <CreateStyled>
        <Form
          onSubmit={(data: FieldValues) =>
            createMerchantNotification(data as MerchantsShowNotificationsFormValues)
          }
        >
          <CardHeader
            appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
            title={translate('app.merchantsShowNotifications.notificationSettingsCreation')}
            titleSize="smallBold"
          />
          <MerchantsShowNotificationsForm eventNames={eventNames} />
          <CardActionsButtons
            rightActionsSlot={[
              <Button
                key="cancel-button"
                label={translate('app.buttons.cancel')}
                onClick={onClose}
                variant="outlined"
              />,
              <Button
                isLoading={isLoading}
                key="create-button"
                label={translate('app.buttons.create')}
                type="submit"
                variant="contained"
              />,
            ]}
          />
        </Form>
      </CreateStyled>
    </Dialog>
  );
};
